import * as React from 'react'
import { config } from 'react-awesome-styled-grid'
import { FadeInImage } from '@components/shared/FadeInImage'
import Link from 'next/link'
import styled from 'styled-components'
import { colors } from '@components/shared'
import type { SeriesInfoPropsType } from '../../models/Series'
import TrackTags from '@components/Tag/TrackTags'
import { getComingSoonText } from '../../models/Track'
import BadgeTextFloat from '@components/BadgeText'

export function SeriesListItemComponent (props: SeriesInfoPropsType): React.ReactNode {
  const {
    title,
    images,
    description,
    episodeInfo,
    thematicTags,
    slug,
    publishedAt
  } = props
  const comingSoon = getComingSoonText(publishedAt)

  return (
    <SeriesItem>
      <SeriesImageContainer>
        {comingSoon && <BadgeTextFloat>{comingSoon}</BadgeTextFloat>}
        <Link passHref href={slug}>
          <FadeInImage layout={'fill'} src={images.img500}/>
        </Link>
      </SeriesImageContainer>
      <SeriesItemInfoContainer>
        <TitleText>
          <Link passHref href={slug}>{title}</Link>
        </TitleText>
        <DescriptionContainer>
          <DescriptionText>{description}</DescriptionText>
          {thematicTags && <TagListPillContainer>
            <TrackTags tags={thematicTags} maxLines={2} clickable={true}/>
          </TagListPillContainer>}
        </DescriptionContainer>
        <EpisodeInfoText>{episodeInfo}</EpisodeInfoText>
      </SeriesItemInfoContainer>
    </SeriesItem>
  )
}

const SeriesItem = styled.div<any>`
    display: flex;
    width: 100%;
    align-items: center;
    ${(props: any): any => config(props).media.xs`
  `}
    ${(props: any): any => config(props).media.sm`
  `}
    ${(props: any): any => config(props).media.md`
      width: 50%;
  `}
    ${(props: any): any => config(props).media.lg`
      width: 30%;
  `}
    ${(props: any): any => config(props).media.xl`
  `}
`

const SeriesItemInfoContainer = styled.div<any>`
  display: flex;
  flex-direction: column;
  margin-left: 8px;  
  ${(props: any): any => config(props).media.xs`
  `}
  ${(props: any): any => config(props).media.sm`
    margin-left: 12px;
  `}
  ${(props: any): any => config(props).media.md`
    margin-left: 16px;
  `}
  ${(props: any): any => config(props).media.lg`
    margin-left: 20px;
  `}
  ${(props: any): any => config(props).media.xl`
  `}
`
const TitleText = styled.div<any>`
    margin-bottom: 5px;
    a {
        text-decoration: none;
        font-family: "Good Sans Regular";
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 125%; /* 125% */
        color: ${colors.white};
    }
    ${(props: any): any => config(props).media.xs`
  `}
    ${(props: any): any => config(props).media.sm`
      a {
          font-size: 16px;
        }
    `}
    ${(props: any): any => config(props).media.md`
      a {
        font-size: 18px;
      }
    `}
    ${(props: any): any => config(props).media.lg`
  `}
    ${(props: any): any => config(props).media.xl`
  `}
`

const DescriptionText = styled.div<any>`
    font-family: "Good Sans Regular";
    font-size: 11px;
    font-style: normal;
    font-weight: 400;
    line-height: 135%; /* 14.85px */
    letter-spacing: -0.3px;
    color: ${colors.white};
    display: -webkit-box;
    text-align: left;
    overflow: hidden;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    max-width: 360px;
    
    ${(props: any): any => config(props).media.md`
      font-size: 14px;
    `}
`

const EpisodeInfoText = styled.p<any>`
    font-family: "Good Sans Regular";
    font-size: 11px;
    font-style: normal;
    font-weight: 400;
    line-height: 130%;
    letter-spacing: -0.3px;
    color: ${colors.white};
    ${(props: any): any => config(props).media.md`
      font-size: 14px;
    `}
`

const TagListPillContainer = styled.div<any>`
    margin-top: 3px;
`

const DescriptionContainer = styled.div<any>`
    
    ${(props: any): any => config(props).media.xs`
  `}
    ${(props: any): any => config(props).media.sm`
  `}
    ${(props: any): any => config(props).media.md`
      
  `}
    ${(props: any): any => config(props).media.lg`
  `}
    ${(props: any): any => config(props).media.xl`
  `}
`

const SeriesImageContainer = styled.div<any>`
    width: 134px;
    height: 134px;
    flex-shrink: 0;
    position: relative;
    img {
        border-radius: 20px;
    }

    ${(props: any): any => config(props).media.xs`
    `}
    ${(props: any): any => config(props).media.sm`
      width: 187px;
      height: 187px;
    `}
    ${(props: any): any => config(props).media.md`
      width: 187px;
      height: 187px;
    `}
    ${(props: any): any => config(props).media.lg`
      width: 200px;
      height: 200px;
    `}
    ${(props: any): any => config(props).media.xl`
    `}
`
